import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }

import {__} from "~/ts/library/Translate";
import KnowledgeBaseDialog from "~/operatorApplication/vue/dialogs/dialog/knowledgeBase/KnowledgeBaseDialog.vue";
import OperatorApplicationDialogTextareaButton
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogTextareaButton.vue";
import {computed, ref} from "vue";
import useTextareaComponent from "~/operatorApplication/vue/dialogs/dialog/textarea/useTextareaComponent";
import SendArticlePayloadInterface, {
    SendGroupPayloadInterface
} from "~/operatorApplication/vue/dialogs/dialog/knowledgeBase/SendArticlePayloadInterface";
import {
    KnowledgeBaseEssenceArticle,
    KnowledgeBaseEssenceGroup
} from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogTextareaModelInterface";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "KnowledgeBaseButton"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let {site, model, focusTextarea} = useTextareaComponent();

let knowledgeBaseDialog = ref<{ visible: boolean }>();

let knowledgeBaseList = computed(() => {
    return site.value?.knowledgeBase ?? [];
});

function showKnowledgeBaseDialog() {
    knowledgeBaseDialog.value = {
        visible: true
    };
}

function onSendKnowledgeBaseArticle(payload: SendArticlePayloadInterface) {
    model.value.knowledgeBase.push({
        essence: KnowledgeBaseEssenceArticle,
        id: payload.articleId,
        registerId: payload.registerId,
        descr: payload.descr
    });
    focusTextarea();
}

function onSendKnowledgeBaseGroup(payload: SendGroupPayloadInterface) {
    model.value.knowledgeBase.push({
        essence: KnowledgeBaseEssenceGroup,
        id: payload.groupId,
        registerId: payload.registerId,
        descr: payload.descr
    });
    focusTextarea();
}



return (_ctx: any,_cache: any) => {
  return (_unref(knowledgeBaseList).length)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createVNode(OperatorApplicationDialogTextareaButton, {
          icon: "book-open-cover",
          tooltip: _unref(__)('База знаний'),
          onClick: showKnowledgeBaseDialog
        }, null, 8, ["tooltip"]),
        (_unref(knowledgeBaseDialog))
          ? (_openBlock(), _createBlock(KnowledgeBaseDialog, {
              key: 0,
              visible: _unref(knowledgeBaseDialog).visible,
              "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_unref(knowledgeBaseDialog).visible) = $event)),
              "knowledge-base-list": _unref(knowledgeBaseList),
              onSendArticle: onSendKnowledgeBaseArticle,
              onSendGroup: onSendKnowledgeBaseGroup
            }, null, 8, ["visible", "knowledge-base-list"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})